import { axiosInstance as apiClient } from './AuthService';

export default {
    validateToken() {
        return apiClient.post('/auth/validate');
    },
    initBot(){
        return apiClient.get('/init')
    },
    startConversation(productId,userEmail){
        return apiClient.post('/conversations/start',{
            productId,userEmail
        });
    },
    sendMessage(conversationId,message){
        return apiClient.post(`/conversations/${conversationId}/messages`,{message});
    },
    uploadAttachments(conversationId, formData) {
        return apiClient.post(`/conversations/${conversationId}/attachments`, formData);
    }
}